import React from 'react'
import TiqetsBookingEngine from './TiqetsBookingEngine'
import { transformHref } from '../overwrites/Link'
import { useTranslation } from 'next-i18next'
import GYGBookingEngine from './GYGBookingEngine'
import { CurrencyDisplay } from '../common/CurrencyDisplay'
import RegiondoBookingEngine from './RegiondoBookingEngine'

type Props = {
  price: Price
  productLink: string
  bookingEngine: string
  productName: string
  enginePartner: string
  productId: string
}

const bookingEngineComponents = {
  getyourguide: (p: any) => <GYGBookingEngine {...p} />,
  regiondo: (p: any) => <RegiondoBookingEngine {...p} />,
  tiqets: (p: any) => <TiqetsBookingEngine {...p} />,
}

export function BookProduct({
  price,
  productLink,
  bookingEngine,
  productName,
  enginePartner,
  productId,
}: Props) {
  const { i18n } = useTranslation('common')
  const handleButtonClick = () => {
    window.open(transformHref(productLink, i18n.language as any), '_blank')
  }
  debugger
  return (
    <div className="w-full flex flex-col gap-4">
      {enginePartner ? (
        bookingEngineComponents[
          enginePartner as keyof typeof bookingEngineComponents
        ]({ bookingEngine, productId })
      ) : (
        <span>
          <div className="w-full flex flex-col gap-4">
            <h1 className="text-xl font-medium">{productName}</h1>
            <div>
              <p className="text-md">
                Preis: <CurrencyDisplay price={price} />
              </p>
            </div>
            {productLink && (
              <button
                onClick={handleButtonClick}
                className="w-full p-2 bg-primary text-white font-medium rounded-lg hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-300"
                aria-label="Book product"
              >
                Direkt buchen
              </button>
            )}
          </div>
        </span>
      )}
    </div>
  )
}
